import { useAtomValue, useSetAtom } from 'jotai';
import { domain } from 'modules/data';
import { useEffect } from 'react';
import { ContentSplitViewMode, contentSplitViewState, ocrIsLoadingState } from 'shared/states';

import { ocrAttachmentIdState, useWrappedCheckOcrStatus } from '../components/SplitViewWrapper/components';

export const useOcrStatus = (
    request:
        | domain.XeroBillRequest
        | domain.XeroInvoiceRequest
        | domain.XeroPoRequest
        | domain.XeroCreditNotesPayableRequest
        | domain.NetSuiteBillRequest
        | domain.QBooksBillRequest
) => {
    const ocrAttachmentInProgress = request.attachments.find(
        (attachment) =>
            attachment.ocrStatus === domain.OcrStatus.InProgress || attachment.ocrStatus === domain.OcrStatus.Requested
    );

    const { checkOcrStatus, isOcrAttachmentInProgress, isFetched } = useWrappedCheckOcrStatus(
        request,
        ocrAttachmentInProgress?.id
    );

    const ocrIsLoading = useAtomValue(ocrIsLoadingState);
    const setOcrAttachmentIdState = useSetAtom(ocrAttachmentIdState);

    const setContentSplitView = useSetAtom(contentSplitViewState);

    useEffect(() => {
        if (ocrAttachmentInProgress && !request.ocrAttachment) {
            if (!ocrIsLoading && (isOcrAttachmentInProgress || !isFetched)) {
                checkOcrStatus();
            }

            setOcrAttachmentIdState(ocrAttachmentInProgress.id);
            setContentSplitView({
                mode: ContentSplitViewMode.AttachmentsToRequest,
                attachmentId: ocrAttachmentInProgress.id,
            });
        }
    }, [
        checkOcrStatus,
        isFetched,
        isOcrAttachmentInProgress,
        ocrAttachmentInProgress,
        ocrIsLoading,
        request,
        setContentSplitView,
        setOcrAttachmentIdState,
    ]);
};
